import axios from 'axios';
import { path, map, filter } from 'ramda';

import {
    APPROVE_PERSON,
    REJECT_PERSON,
    APPROVE_PROJECT,
    REJECT_PROJECT
} from 'constants/actionTypes';
import * as urls from 'constants/urls';

export const postRequestDocumentHandler = ({ payload: { id, documentsUpload = [] } }) =>
    Array.isArray(documentsUpload) ? (
        axios.fullAll(
            filter(d => !d.id, documentsUpload).map(
                doc => axios.post(urls.REQUEST_DOCUMENT.stringify(), ({
                    ...doc,
                    fileExt: doc.fileType,
                    docType: doc.documentType,
                    docTypeInt: 1,
                }), {
                    params: {
                        objkey: id,
                        objtype: 'RequestIntRecr',
                    }
                })
            )
        ).catch(({ errors }) =>
            Promise.reject({ objkey: id, documentErrors: errors, translate: 'errors.saveDocumentError', })
        )
    ) : Promise.reject();

export const addRequestHandler = ({ payload: { documentsUpload, ...data }, ...action }) => {
    const id = path(['attrs', 'error', 'objkey'], action);

    if (id) {
        return postRequestDocumentHandler({ payload: { id, documentsUpload } })
            .then(() => ({ id }))
    } else {
        return axios.post(urls.ADD_REQUEST.stringify(), data)
            .then(objkey => {
                return postRequestDocumentHandler({ payload: { id: objkey, documentsUpload } })
                    .then(() => ({ objkey }))
            })
    }
};

export const getRequestSettingsHandler = () => axios.get(urls.REQUEST_SETTINGS.stringify());
export const getRequestHandler = ({ payload }) => axios.get(urls.REQUEST.stringify({ id: payload }));
export const getApprovalPersonHandler = ({ payload }) => axios.get(urls.APPROVAL_PERSON.stringify({ id: payload.id }),
    { params: { authtoken: payload.token } });
export const getApprovalProjectHandler = ({ payload }) => axios.get(urls.APPROVAL_PROJECT.stringify({ id: payload.id }),
    { params: { authtoken: payload.token } });

export const getPersonHandler = ({ payload }) => axios.get(urls.PERSON.stringify({ id: payload }));
export const getProjectHandler = ({ payload }) => axios.get(urls.PROJECT.stringify({ id: payload }));
export const getProjectMassHandler = ({ payload }) => axios.get(urls.PROJECT_MASS.stringify({
    userId: payload.userId,
    prjId: payload.prjId
}));

export const getDocumentHandler = ({ payload }) => axios.get(urls.DOCUMENT.stringify({
    id: payload.id,
    place: payload.place || '3'
}));

export const getDocumentInfoHandler = ({ payload }) => axios.get(urls.DOCUMENT_INFO.stringify({
    id: payload.id,
    place: payload.place || '3'
}));

export const putDocumentTextHandler = ({ payload: { id, ...payload } }) => (
    axios.put(urls.DOCUMENT_TEXT.stringify({ id }), payload)
);

export const putDocumentXMLHandler = ({ payload: { id, ...payload } }) => (
    axios.put(urls.DOCUMENT_XML.stringify({ id }), payload)
);

export const getCompanyHandler = ({ payload }) => axios.get(urls.COMPANY.stringify({ id: payload }))

export const postCancelRequestHandler = ({ payload: { ids, comment }}) => {
    return axios.all(map((id) => axios.put(urls.CANCEL_REQUEST.stringify(), { id, comment }), ids));
}

const createMultipleRequestHandler = (action) => {
    return ({ payload: { ids, comment }}) => {
        return axios.all(map((id) => axios.post(urls[action].stringify({ id }), { comment }), ids));
    };
}

export const postApprovePersonHandler = createMultipleRequestHandler(APPROVE_PERSON);
export const postRejectPersonHandler = createMultipleRequestHandler(REJECT_PERSON);
export const postApproveProjectHandler = createMultipleRequestHandler(APPROVE_PROJECT);
export const postRejectProjectHandler = createMultipleRequestHandler(REJECT_PROJECT);

export const createEventHandler = ({ payload }) => axios.post(urls.EVENT.stringify(), payload);
export const updateEventHandler = ({ payload }) => axios.put(urls.EVENT.stringify({ id: payload.id }), payload);
export const getEventHandler = ({ payload }) => axios.get(urls.EVENT.stringify({ id: payload }));
export const getScriptHandler = ({ payload }) => axios.get(urls.EVENT_SCRIPT.stringify({ id: payload }));

export const postEmailApproval = ({ payload }) => axios.post(urls.EMAIL_APPROVAL.stringify(), payload);
